import type {PayloadAction} from "@reduxjs/toolkit";
import {createSlice} from "@reduxjs/toolkit";

import type {QueryError} from "../util/errorUtil";

export type LoginStatus = "init" | "idle" | "loading" | "failed";

interface LoginState {
    error: string | null;
    errorArgs: object;
    errorHasContactLink: boolean;
    status: LoginStatus;
}

const initialState: LoginState = {
    error: "",
    errorArgs: {},
    errorHasContactLink: false,
    status: "init",
};

export const loginSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
        setIdle: (state) => {
            state.error = "";
            state.errorArgs = {};
            state.errorHasContactLink = false;
            state.status = "idle";
        },
        setLoading: (state) => {
            state.error = "";
            state.errorArgs = {};
            state.errorHasContactLink = false;
            state.status = "loading";
        },
        setError: (state, action: PayloadAction<QueryError>) => {
            state.error = action.payload.error;
            state.errorArgs = action.payload.errorArgs ?? {};
            state.errorHasContactLink = action.payload.errorHasContactLink;
            state.status = "failed";
        },
    },
    selectors: {
        selectStatus: (state) => state.status,
        selectError: (state) => state.error,
        selectErrorArgs: (state) => state.errorArgs,
        selectErrorHasContactLink: (state) => state.errorHasContactLink,
    },
});

export const {setIdle, setLoading, setError} = loginSlice.actions;

export const {selectStatus, selectError, selectErrorArgs, selectErrorHasContactLink} = loginSlice.selectors;

export default loginSlice.reducer;
